import { ChartConfig, ChartSeries } from 'components/Charts/types';
import { transformMoicSeries } from './moicSeriesTransform';

/**
 * MOIC bar chart configuration
 */
export const getMoicChartConfig = (moicSeries: ChartSeries[]): ChartConfig => ({
  title: '',
  xAxis: { label: 'Date' },
  yAxis: { label: 'MOIC' },
  legend: { show: true, position: 'top' },
  tooltip: { show: true },
  options: {
    animation: true,
    animationDuration: 1000,
    animationEasing: 'elasticOut',
    // Stagger each bar animation - more pronounced delay
    animationDelay: (idx: number) => idx * 250,
    animationDurationUpdate: 1000,
    animationEasingUpdate: 'elasticOut',
    animationDelayUpdate: (idx: number) => idx * 250,
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(155, 89, 182, 0.1)',
        },
      },
      backgroundColor: 'rgba(50, 50, 93, 0.95)',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: 1,
      textStyle: {
        color: '#fff',
        fontSize: 12,
      },
      padding: [10, 15],
      formatter: (params: any) => {
        const param = Array.isArray(params) ? params[0] : params;
        return `
          <div style="font-weight: 600; margin-bottom: 5px;">${param.name}</div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 10px; height: 10px; background: ${param.color}; border-radius: 50%;"></span>
            <span>${param.seriesName}: <strong style="color: ${param.color};">${param.value?.toFixed(2) || 0}x</strong></span>
          </div>
        `;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '8%',
      top: '15%',
      containLabel: true,
    },
    // Transform series to include per-bar colors and animations
    // Each bar will animate individually with staggered delays
    series: transformMoicSeries(moicSeries),
  },
});
